<template>
  <div class="news">
    <div class="container-fluid vmc-py-big">
      <div class="container">

        <div class="row">
          <div class="col-12 text-center">
            <h2 class="h1 vmc-text-primary vmc-heading">
              Company News
            </h2>
          </div>
        </div>

        <div v-for="article in companyNewsList" :key="article.id" class="row">
          <div class="col-12 my-2">
            <div class="card">
              <div class="row no-gutters d-flex align-items-center">

                <div class="col-md-5">
                  <!-- CHANGED: support images array similar to AllNews.vue -->
                  <img class="card-img"
                    :src="(article.images && article.images.length > 0) ? article.images[0] : (article.image || require('@/assets/no_image.jpg'))"
                    alt="News Image" style="object-fit: cover; height: 100%; min-height: 250px;">
                </div>

                <div class="col-md-7">
                  <div class="card-body">

                    <div class="font font-weight-normal mb-1">
                      <h4 class="title-clamp">{{ article.title }}</h4>
                    </div>

                    <div class="letter-spacing-1">
                      <p class="author-date-clamp">
                        By {{ article.author }} — {{ formattedDate(article.date) }}
                      </p>
                    </div>

                    <div class="d-none d-lg-block">
                      <p class="news-clamp"> {{ article.content }}</p>
                    </div>

                    <router-link class="vmc-text-primary-2" :to="'/news/' + article.id">continue reading . .
                      .</router-link> <!-- Link to full article -->

                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
        <div v-if="companyNewsList.length === 0" class="row mt-5">
          <div class="col-12 text-center">
            <p class="text-muted">No company news updates available at the moment.</p>
            <!-- appears when there are no company news articles -->
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
// 1. Import the CMS Mixin
import { cmsMixin } from '@/mixins/cmsMixin';

export default {
  name: 'CompanyNews',
  mixins: [cmsMixin], // 2. Connect the mixin
  computed: {
    companyNewsList() {
      // Safety check
      if (!this.cms.newsArticles) return [];

      // 1. Filter (Get only Company News)
      // 2. Sort (Newest Date First)
      return this.cms.newsArticles
        .filter(article => article.category === 'Company News')
        .sort((a, b) => new Date(b.date) - new Date(a.date));
    }
  },

  methods: {
    formattedDate(date) {
      if (!date) return '';
      const dateString = String(date).split('|')[0].trim();
      const dateObj = new Date(dateString);
      
      // Check if date is valid
      if (isNaN(dateObj.getTime())) {
        return '';
      }
      
      return dateObj.toLocaleDateString('en-US', { 
        year: 'numeric', 
        month: 'short', 
        day: 'numeric' 
      });
    }
  }
};
</script>

<style scoped>
/* Keeping your exact style requirements */
.news-clamp {
  display: -webkit-box;
  -webkit-line-clamp: 5;
  /* Limits text to specified amount of lines so cards stay neat */
  -webkit-box-orient: vertical;
  overflow: hidden;
  margin-bottom: 10px;
}

.author-date-clamp {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  /* Limits text to specified amount of lines so cards stay neat */
  -webkit-box-orient: vertical;
  overflow: hidden;
  margin-bottom: 10px;
  color: #85a8c7;
}

.title-clamp {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  /* Limits text to specified number lines. Change this number to fit perfectly. */
  -webkit-box-orient: vertical;
  overflow: hidden;
  margin-bottom: 10px;
}
</style>


{<!-- <template>
  <div class="news">
    <div class="container-fluid vmc-py-big">
      <div class="container">
        <div class="row">
          <div class="col-12 text-center">
            <h2 class="h1 vmc-text-primary vmc-heading">
              Company News
            </h2>
          </div>
        </div>

        <div class="row">
          <div class="col-12 my-2">
            <div class="card">
              <div class="row no-gutters d-flex align-items-center">
                <div class="col-md-5">
                  <img class="card-img" :src="news33" alt="Veritas 35th Anniversary Celebration at the Manila Hotel">
                </div>
                <div class="col-md-7">
                  <div class="card-body">
                    <h4 class="font-weight-normal mb-1">Veritas 35th Anniversary Celebration at the Manila Hotel</h4>
                    <p class="vmc-text-primary-2 letter-spacing-1">
                      By Veritas Admin — July 28, 2024
                    </p>
                    <p class="d-none d-lg-block">
                      Veritas held its 35th Anniversary Celebration at the Manila Hotel –Centennial Hall last July 11, 2024.  Event was well attended by different sectors of government, industry, and other business associates and partners. Congratulatory speeches were given by Asec. Jerome Pampolina of the Department of Migrant Workers (DMW), Mr. Toshihito Inoue, Chairman of International Mariners Management Association of Japan (IMMAJ), Capt. Kazumi Tomi, President of Kagoshima Senpaku Kaisha Ltd., and Capt. Nobuyoshi Hiratsuka, Executive Officer of “K” Line Roro Bulk Ship Management Co. Ltd. (KRBS).
                    </p>
                    <router-link class="vmc-text-primary-2" :to="{name: 'Vmc35Anniversary2024'}">continue reading . . .</router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12 my-2">
            <div class="card">
              <div class="row no-gutters d-flex align-items-center">
                <div class="col-md-5">
                  <img class="card-img" :src="news31" alt="2024 Veritas Crew and Family Parties - Cebu and Bohol">
                </div>
                <div class="col-md-7">
                  <div class="card-body">
                    <h4 class="font-weight-normal mb-1">2023 Veritas Maritime Corporation Staff Christmas Party</h4>
                    <p class="vmc-text-primary-2 letter-spacing-1">
                      By Veritas Admin — December 20, 2023
                    </p>
                    <p class="d-none d-lg-block">
                      The Veritas Maritime Corporation staff party was held last 08 December 2023 at Marc 2000 Tower’s Penthouse, with the theme “At the Movies”. The event was attended by a total of 195 participants (84 staff and 111 Family/Guests).
                    </p>
                    <router-link class="vmc-text-primary-2" :to="{name: 'VmcStaffXmasParty2023'}">continue reading . . .</router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12 my-2">
            <div class="card">
              <div class="row no-gutters d-flex align-items-center">
                <div class="col-md-5">
                  <img class="card-img" :src="news26" alt="Covid Cases">
                </div>
                <div class="col-md-7">
                  <div class="card-body">
                    <h4 class="font-weight-normal mb-1">Veritas Maritime Corporation 33rd Anniversary</h4>
                    <p class="vmc-text-primary-2 letter-spacing-1">
                      By Veritas Admin — July 12, 2022
                    </p>
                    <p class="d-none d-lg-block">
                      Congratulations VERITAS for another fruitful year! 33 years and stronger!
                    </p>
                    <router-link class="vmc-text-primary-2" :to="{name: 'VMC33rdAnniversary'}">continue reading . . .</router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 my-2">
            <div class="card">
              <div class="row no-gutters d-flex align-items-center">
                <div class="col-md-5">
                  <img class="card-img" :src="news24" alt="Suresh Dasari Card">
                </div>
                <div class="col-md-7">
                  <div class="card-body">
                    <h4 class="font-weight-normal mb-1">QMS-2022-010 MLC Certified and ISO Certified</h4>
                    <p class="vmc-text-primary-2 letter-spacing-1">
                      By Veritas Admin — May 20, 2022
                    </p>
                    <p class="d-none d-lg-block">
                      QMS-2022-010 Congratulations Veritas Family for being MLC Certified and ISO Certified
                    </p>
                    <router-link class="vmc-text-primary-2" :to="{name: 'MLCCertifiedAndISOCertified'}">continue reading . . .</router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 my-2">
            <div class="card">
              <div class="row no-gutters d-flex align-items-center">
                <div class="col-md-5">
                  <img class="card-img" :src="news23" alt="Suresh Dasari Card">
                </div>
                <div class="col-md-7">
                  <div class="card-body">
                    <h4 class="font-weight-normal mb-1">A Woman Like No Other</h4>
                    <p class="vmc-text-primary-2 letter-spacing-1">
                      By Veritas Admin — May 08, 2022
                    </p>
                    <p class="d-none d-lg-block">
                      Miss Naty… a woman like no other, who dedicated 31 years of her life at Veritas Maritime Corporation, and still actively mentoring the next generation of leaders, extending her motherly love to all the office staff and crew surrounding her on and off work.
                    </p>
                    <router-link class="vmc-text-primary-2" :to="{name: 'AWomanLikeNoOther2022'}">continue reading . . .</router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-12 my-2">
            <div class="card">
              <div class="row no-gutters d-flex align-items-center">
                <div class="col-md-5">
                  <img class="card-img" :src="news18" alt="Suresh Dasari Card">
                </div>
                <div class="col-md-7">
                  <div class="card-body">
                    <h4 class="font-weight-normal mb-1">Health and Wealth Summit Oct 2021</h4>
                    <p class="vmc-text-primary-2 letter-spacing-1">
                      By Veritas Admin — October 20, 2021
                    </p>
                    <p class="d-none d-lg-block"></p>
                    <router-link class="vmc-text-primary-2" :to="{name: 'HealthWealthSummitOct2021'}">continue reading . . .</router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 my-2">
            <div class="card">
              <div class="row no-gutters d-flex align-items-center">
                <div class="col-md-5">
                  <img class="card-img" :src="news13" alt="Suresh Dasari Card">
                </div>
                <div class="col-md-7">
                  <div class="card-body">
                    <h4 class="font-weight-normal mb-1">My Personal Experience with Veritas Maritime Corporation</h4>
                    <p class="vmc-text-primary-2 letter-spacing-1">
                      By Veritas Admin — July 10, 2021
                    </p>
                    <p class="d-none d-lg-block">
                      I, Penelope L. Lumanog graduated on December 2019 at Centro Escolar University and looked for a job in various platforms such as jobstreet. I have applied to a lot of companies and went on interviews, but what really picked my interest and attention was the Veritas Maritime Corporation.
                    </p>
                    <router-link class="vmc-text-primary-2" :to="{name: 'MyPersonalExperiencePenelopeLumanog'}">continue reading . . .</router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 my-2">
            <div class="card">
              <div class="row no-gutters d-flex align-items-center">
                <div class="col-md-5">
                  <img class="card-img" :src="news15" alt="Suresh Dasari Card">
                </div>
                <div class="col-md-7">
                  <div class="card-body">
                    <h4 class="font-weight-normal mb-1">Health and Wealth Summit</h4>
                    <p class="vmc-text-primary-2 letter-spacing-1">
                      By Veritas Admin — July 7, 2021
                    </p>
                    <p class="d-none d-lg-block"></p>
                    <router-link class="vmc-text-primary-2" :to="{name: 'HealthWealthSummit2021'}">continue reading . . .</router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 my-2">
            <div class="card">
              <div class="row no-gutters d-flex align-items-center">
                <div class="col-md-5">
                  <img class="card-img" :src="news5" alt="Suresh Dasari Card">
                </div>
                <div class="col-md-7">
                  <div class="card-body">
                    <h4 class="font-weight-normal mb-1">Veritas Christmas Video 2020</h4>
                    <p class="vmc-text-primary-2 letter-spacing-1">
                      By Veritas Admin — December 25, 2020
                    </p>
                    <p class="d-none d-lg-block">
                      The talented and hardworking staff of Veritas made a video tribute for the Christmas season to remind us that we are one family facing this pandemic.
                    </p>
                    <router-link class="vmc-text-primary-2" :to="{name: 'VeritasChristmasVideo2020'}">continue reading . . .</router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 my-2">
            <div class="card">
              <div class="row no-gutters d-flex align-items-center">
                <div class="col-md-5">
                  <img class="card-img" :src="news8" alt="Suresh Dasari Card">
                </div>
                <div class="col-md-7">
                  <div class="card-body">
                    <h4 class="font-weight-normal mb-1">BOQ TNKC House Inspection 2020</h4>
                    <p class="vmc-text-primary-2 letter-spacing-1">
                      By Veritas Admin — July 8, 2021
                    </p>
                    <router-link class="vmc-text-primary-2" :to="{name: 'BoqTnkcHouseInspection'}">continue reading . . .</router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 my-2">
            <div class="card">
              <div class="row no-gutters d-flex align-items-center">
                <div class="col-md-5">
                  <img class="card-img" :src="news9" alt="Suresh Dasari Card">
                </div>
                <div class="col-md-7">
                  <div class="card-body">
                    <h4 class="font-weight-normal mb-1">TNKC House Swab Test 2020</h4>
                    <p class="vmc-text-primary-2 letter-spacing-1">
                      By Veritas Admin — July 8, 2021
                    </p>
                    <router-link class="vmc-text-primary-2" :to="{name: 'TnkcHouseSwabTest'}">continue reading . . .</router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 my-2">
            <div class="card">
              <div class="row no-gutters d-flex align-items-center">
                <div class="col-md-5">
                  <img class="card-img" :src="news10" alt="Suresh Dasari Card">
                </div>
                <div class="col-md-7">
                  <div class="card-body">
                    <h4 class="font-weight-normal mb-1">Joining Crew 2020</h4>
                    <p class="vmc-text-primary-2 letter-spacing-1">
                      By Veritas Admin — July 8, 2021
                    </p>
                    <router-link class="vmc-text-primary-2" :to="{name: 'JoiningCrewBritainBay2020'}">continue reading . . .</router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 my-2">
            <div class="card">
              <div class="row no-gutters d-flex align-items-center">
                <div class="col-md-5">
                  <img class="card-img" :src="news11" alt="Suresh Dasari Card">
                </div>
                <div class="col-md-7">
                  <div class="card-body">
                    <h4 class="font-weight-normal mb-1">New Normal Office 2020</h4>
                    <p class="vmc-text-primary-2 letter-spacing-1">
                      By Veritas Admin — July 8, 2021
                    </p>
                    <router-link class="vmc-text-primary-2" :to="{name: 'NewNormalOffice2020'}">continue reading . . .</router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 my-2">
            <div class="card">
              <div class="row no-gutters d-flex align-items-center">
                <div class="col-md-5">
                  <img class="card-img" :src="news1" alt="Suresh Dasari Card">
                </div>
                <div class="col-md-7">
                  <div class="card-body">
                    <h4 class="font-weight-normal mb-1">Carrying a family legacy toward growth, stability</h4>
                    <p class="vmc-text-primary-2 letter-spacing-1">
                      By Yashika F. Torib — July 17, 2019
                    </p>
                    <p class="d-none d-lg-block">One of the country’s pioneers in the maritime manning sector, Veritas Maritime Corp. welcomed on July 11 its new leader, Francis Jerome “Jiro” Marquez, to family, friends and colleagues.</p>
                    <router-link class="vmc-text-primary-2" :to="{name: 'CarryingAFamilyLegacyTowardGrowthStability'}">continue reading . . .</router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 my-2">
            <div class="card">
              <div class="row no-gutters d-flex align-items-center">
                <div class="col-md-5">
                  <img class="card-img" :src="news4" alt="Suresh Dasari Card">
                </div>
                <div class="col-md-7">
                  <div class="card-body">
                    <h4 class="font-weight-normal mb-1">Veritas 30th Anniversary Same Day Edit Video</h4>
                    <p class="vmc-text-primary-2 letter-spacing-1">
                      By Veritas Admin — July 11, 2019
                    </p>
                    <p class="d-none d-lg-block">
                      Same day video shoot and edit for the 30th-anniversary celebration of Veritas.
                    </p>
                    <router-link class="vmc-text-primary-2" :to="{name: 'Veritas30thAnniversarySameDayEditVideo'}">continue reading . . .</router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CompanyNews',
  data() {
    return {
      'news1': require(`@/assets/news/news_17-06-2019.jpg`),
      'news4': require(`@/assets/news/news_28-04-2021-30thAnniversary.jpg`),
      'news5': require(`@/assets/news/news_28-04-2021-XmasParty.jpg`),
      'news8': require(`@/assets/news/2020/tnkcinspection/boqinspect1_7-8-2021.jpg`),
      'news9': require(`@/assets/news/2020/tnkcswabtest/swab1_7-8-2021.jpg`),
      'news10': require(`@/assets/news/2020/joiningcrew/crew1_7-8-2021.jpg`),
      'news11': require(`@/assets/news/2020/newnormaloffice/office1_7-8-2021.jpg`),
      'news13': require(`@/assets/news/newsStaff_7-10-2021.jpg`),
      'news15': require(`@/assets/programs/csr/2021/healthwealth/health2_7-9-2021.jpg`),
      'news18': require(`@/assets/programs/office/2021/healthwealth/health1_18-10-2021.jpg`),
      'news23': require(`@/assets/news/2022WomanLikeNoOther.jpg`),
      'news24': require(`@/assets/news/2022/may/mlcisocert_52022-thumbnail.jpg`),
      'news26': require(`@/assets/news/2022/jul/33rd_anniversary_0714-A.jpg`),
      'news31': require(`@/assets/news/2023/StaffXmasParty.png`),
      'news33': require(`@/assets/news/2024/anniversary/Anniversary35A.jpg`),
    }
  }
};
</script>

<style scoped>

</style> -->}
